import { UserRoles } from "common/enums";
import * as appRoutes from "config/routes.config";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ContactUs from "screens/teacher/components/contactUs";
import AnimatedPage from "utils/animatedPage";
import ChooseTeacher from "./components/chooseTeacher";
import NeedHelp from "./components/needHelp";
import OurHistory from "./components/ourHistory";
import OurMission from "./components/ourMission";
import OurResources from "./components/ourResources";
import OurValues from "./components/ourValues";
import SlideHome from "./components/slide";
import StudentsTestimonies from "./components/testimonies";
import WhyChooseUs from "./components/WhyChooseUs";

const HomePage = () => {
  //!HOOKS
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const { isAppInMaintenance } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const location = useLocation();

  //!EFFECTS
  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
    const isStudent = auth.user?.roles?.includes(UserRoles.STUDENT);
    if (isLoggedIn && isTeacher) {
      navigate(appRoutes.TEACHER_ACTIVITIES);
    }
    if (isLoggedIn && isStudent) {
      navigate(appRoutes.TEACHER_ACTIVITIES);
    }
  }, [auth.isLoggedIn, navigate, auth.user?.roles]);

  useEffect(() => {
    const affiliateToken = localStorage.getItem("affiliateToken");
    if (affiliateToken) {
      navigate('login/student', {
        state: { link: `feeds?token=${affiliateToken}` },
      });
    }
  }, []);

  useEffect(() => {
    const classCode = localStorage.getItem("classCode");
    if (classCode) {
      navigate('login/student', {
        state: { link: `eleve/mes-classes?classCode=${classCode}` },
      });
    }
  }, []);

  useEffect(() => {
    const organismToken = localStorage.getItem("organismToken");
    const organismClassCode = localStorage.getItem("organismClassCode");
    const userType = localStorage.getItem("userType");
    if (organismToken && organismClassCode && userType) {
      if (userType === "student") {
        navigate('login/student');
      }
      else {
        navigate('login/teacher');
      }
    }
  }, []);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  return (
    <AnimatedPage>
      <SlideHome />
      <OurMission />
      <ChooseTeacher />
      <NeedHelp />
      <OurResources />
      <OurValues />
      <OurHistory />
      <WhyChooseUs />
      <StudentsTestimonies />
      <ContactUs from="landing" />
    </AnimatedPage>
  );
};

export default HomePage;
